/* ===== Route Guard: Zetyar Platform Super Admin Only ===== */

import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useApp } from '@/presentation/providers/useApp'

export function RequireSuperAdmin({ children }: { children: ReactNode }) {
  const { isLoading, profile } = useApp()

  if (isLoading) return null

  if (!profile?.isSuperAdmin) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}
